// @flow

import { RESORT_SUMMARY } from 'Client/cms/toolkit/constants';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { addTranslationKeys } from 'Src/i18n';
import resortThumbnailQuery, {
  type ThumbnailProduct,
} from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { LINE_PRODUCT_SUMMARY } from 'Utils/request/requestDictionary';

type CMSProps = {
  color: BrandColors,
  resortId: string,
  tourDurationPlaceholder: string,
  cruiseTimingPlaceholder: string,
  cruiseDurationPlaceholder: string,
  dateFormat: string,
};

type GQLProps = {
  product: ThumbnailProduct,
  config: $Shape<{
    common: {
      close: string,
      thumbnailCTA: string,
      thumbnailTourCTA: string,
    },
  }>,
};

export type ProductSummaryDescriptorProps = {
  ...$Exact<CMSProps>,
  ...$Exact<GQLProps>,
};

export const productSummaryResolver = {
  name: RESORT_SUMMARY,
  resolve(appContext: AppContext, props: CMSProps): Promise<?GQLProps> {
    const { cmsContent = '', cmsRelease = '' } = appContext;
    const cmsArgs = `content : "${cmsContent}", release : "${cmsRelease}"`;
    const {
      resortId,
      tourDurationPlaceholder,
      cruiseTimingPlaceholder,
      cruiseDurationPlaceholder,
      dateFormat,
    } = props;
    const resortThumbnailQueryString = resortThumbnailQuery({
      content: cmsContent,
      release: cmsRelease,
      tourDurationPlaceholder,
      cruiseTimingPlaceholder,
      cruiseDurationPlaceholder,
      dateFormat,
    });

    const query = `query {
      product : resort(productId : "${resortId}") {
        description
        ${resortThumbnailQueryString}
      }
      config(${cmsArgs}) {
        ${configQueries.resort(appContext)}
        ${configQueries.price()}
        common {
          next
          previous
          close
          thumbnailCTA
          thumbnailTourCTA
        }
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, { requestName: LINE_PRODUCT_SUMMARY, strictErrors: false })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      })
      .catch(() => {});
  },
};
